import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { isServerSide } from 'utility/constant';

export const useUpdateQueryParam = () => {
  const router = useRouter();

  const updateQueryParamWithoutNavigation = useCallback(
    (step: string) => {
      if (isServerSide) return;

      try {
        const newQuery = { ...router.query, step };

        const params = new URLSearchParams();
        params.set('step', step);

        Object.entries(newQuery)
          .filter(([key, value]) => value && key !== 'step')
          .forEach(([key, value]) => params.set(key, String(value)));

        const queryString = params.toString();
        const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`;

        window.history.replaceState({ ...window.history.state, as: newUrl, url: newUrl }, '', newUrl);

        router.query = newQuery;
      } catch (error) {
        console.error('Error updating query params');
      }
    },
    [router]
  );

  return updateQueryParamWithoutNavigation;
};
